// Mock data for NEXEN DIGITAL website

export const services = [
  {
    id: 1,
    title: "Website Development",
    description: "Create stunning, responsive websites that captivate your audience and drive conversions. Built with modern technologies and AI-first approach for optimal performance.",
    features: [
      "Custom responsive design",
      "SEO optimization",
      "Fast loading times",
      "AI-powered content suggestions"
    ],
    icon: "Globe"
  },
  {
    id: 2,
    title: "Web App Development",
    description: "Build powerful, scalable web applications tailored to your business needs. Our AI-first development ensures efficiency and innovation at every step.",
    features: [
      "Custom functionality",
      "Cloud integration",
      "Real-time features",
      "AI-driven automation"
    ],
    icon: "Code"
  },
  {
    id: 3,
    title: "Mobile App Development",
    description: "Transform your ideas into powerful mobile applications for iOS and Android. Leverage AI capabilities for smarter, more intuitive user experiences.",
    features: [
      "Cross-platform development",
      "Native performance",
      "Push notifications",
      "AI-powered features"
    ],
    icon: "Smartphone"
  }
];

export const portfolioProjects = [
  {
    id: 1,
    title: "FinTech Dashboard",
    category: "Web App Development",
    description: "AI-powered financial analytics platform with real-time data visualization and predictive insights.",
    technologies: ["React", "Node.js", "AI/ML", "MongoDB"],
    status: "Completed",
    year: 2024
  },
  {
    id: 2,
    title: "E-Commerce Platform",
    category: "Website Development",
    description: "Modern e-commerce solution with AI-driven product recommendations and smart inventory management.",
    technologies: ["Next.js", "Stripe", "AI", "PostgreSQL"],
    status: "Completed",
    year: 2024
  },
  {
    id: 3,
    title: "Healthcare Mobile App",
    category: "Mobile App Development",
    description: "Patient management app with AI-powered symptom checker and appointment scheduling.",
    technologies: ["React Native", "Firebase", "AI/ML"],
    status: "Completed",
    year: 2023
  },
  {
    id: 4,
    title: "Real Estate Portal",
    category: "Web App Development",
    description: "Property listing platform with AI-based price predictions and virtual tours.",
    technologies: ["React", "Django", "AI", "PostgreSQL"],
    status: "Completed",
    year: 2023
  },
  {
    id: 5,
    title: "Education Platform",
    category: "Website Development",
    description: "Online learning platform with AI-powered personalized learning paths and progress tracking.",
    technologies: ["Vue.js", "Laravel", "AI", "MySQL"],
    status: "Completed",
    year: 2024
  },
  {
    id: 6,
    title: "Logistics Tracking App",
    category: "Mobile App Development",
    description: "Fleet management application with AI-optimized route planning and real-time tracking.",
    technologies: ["Flutter", "Node.js", "AI", "MongoDB"],
    status: "Completed",
    year: 2023
  }
];

export const jobListings = [
  {
    id: 1,
    title: "Senior Full Stack Developer",
    department: "Engineering",
    location: "Bhubaneswar, India",
    type: "Full-time",
    experience: "5+ years",
    description: "We're looking for an experienced Full Stack Developer to join our AI-first development team. You'll work on cutting-edge projects using modern technologies.",
    requirements: [
      "5+ years of experience in full stack development",
      "Proficiency in React, Node.js, and databases",
      "Experience with AI/ML integrations",
      "Strong problem-solving skills",
      "Excellent communication abilities"
    ],
    responsibilities: [
      "Develop and maintain web applications",
      "Collaborate with AI team for integrations",
      "Write clean, maintainable code",
      "Mentor junior developers",
      "Participate in code reviews"
    ]
  },
  {
    id: 2,
    title: "UI/UX Designer",
    department: "Design",
    location: "Bhubaneswar, India",
    type: "Full-time",
    experience: "3+ years",
    description: "Join our creative team to design beautiful and intuitive user experiences for web and mobile applications.",
    requirements: [
      "3+ years of UI/UX design experience",
      "Proficiency in Figma, Adobe XD",
      "Strong portfolio demonstrating design skills",
      "Understanding of user-centered design principles",
      "Experience with prototyping tools"
    ],
    responsibilities: [
      "Create user interface designs",
      "Conduct user research and testing",
      "Develop design systems",
      "Collaborate with developers",
      "Present design concepts to stakeholders"
    ]
  },
  {
    id: 3,
    title: "Mobile App Developer",
    department: "Engineering",
    location: "Bhubaneswar, India",
    type: "Full-time",
    experience: "3+ years",
    description: "Build innovative mobile applications for iOS and Android using modern frameworks and AI-first approach.",
    requirements: [
      "3+ years of mobile app development experience",
      "Proficiency in React Native or Flutter",
      "Experience with native iOS/Android development",
      "Knowledge of mobile UI/UX best practices",
      "Experience with RESTful APIs"
    ],
    responsibilities: [
      "Develop mobile applications",
      "Optimize app performance",
      "Integrate AI features",
      "Test and debug applications",
      "Stay updated with mobile trends"
    ]
  },
  {
    id: 4,
    title: "AI/ML Engineer",
    department: "Engineering",
    location: "Bhubaneswar, India",
    type: "Full-time",
    experience: "4+ years",
    description: "Lead our AI initiatives by developing and implementing machine learning models that enhance our development process.",
    requirements: [
      "4+ years of experience in AI/ML",
      "Proficiency in Python, TensorFlow, PyTorch",
      "Experience with NLP and computer vision",
      "Strong mathematical and statistical skills",
      "Experience deploying ML models in production"
    ],
    responsibilities: [
      "Develop AI/ML models",
      "Integrate AI into applications",
      "Optimize model performance",
      "Research latest AI technologies",
      "Mentor team on AI best practices"
    ]
  }
];

export const companyInfo = {
  name: "NEXEN DIGITAL",
  tagline: "AI-First Development Agency",
  location: "Bhubaneswar, India",
  email: "hello@nexendigital.com",
  phone: "+91-9556898310",
  about: "NEXEN DIGITAL is a cutting-edge development agency based in Bhubaneswar, India. We specialize in creating exceptional websites, web applications, and mobile apps using an AI-first approach. Our team combines technical excellence with innovative AI solutions to deliver fast, efficient, and future-ready digital products.",
  mission: "To revolutionize digital development by integrating AI at every stage, delivering superior quality products faster and more efficiently than traditional methods.",
  vision: "To become the leading AI-first development agency, setting new standards in speed, quality, and innovation in the digital landscape.",
  values: [
    {
      title: "Innovation First",
      description: "We embrace cutting-edge technologies and AI to push boundaries."
    },
    {
      title: "Quality Driven",
      description: "Excellence in every line of code and every pixel of design."
    },
    {
      title: "Client Focused",
      description: "Your success is our success. We build solutions that deliver results."
    },
    {
      title: "Fast Delivery",
      description: "AI-powered development enables us to deliver faster without compromising quality."
    }
  ],
  stats: [
    { label: "Projects Completed", value: "50+" },
    { label: "Happy Clients", value: "35+" },
    { label: "Team Members", value: "15+" },
    { label: "Years Experience", value: "5+" }
  ]
};